import moment from "moment";
import Component from "vue-class-component";
import { EntiteAttenteTransfertDto } from "../../dto/GenApi.iNotPaie.Dto/EntiteAttenteTransfertDto";
import { EtatTransfertEnum } from "../../dto/GenApi.iNotPaie.Dto/EtatTransfertEnum";
import { NatureTransfertEnum } from "../../dto/GenApi.iNotPaie.Dto/NatureTransfertEnum";
import { NotificationServiceInstance } from "../../shared/services/notification.service";
import { EventBus } from "../Controls/EventBus";
import EventConstants from "../Controls/EventConstants";
import { ServicesFactoryInstance } from "../Controls/ServicesFactory";
import { VueBase } from "../Controls/VueBase";
import { ModalAlerteOptions } from "../modalComponents/modalAlerte/modalAlerte";

export interface EntiteAttenteTransfertViewModel extends EntiteAttenteTransfertDto {
    isSelected: boolean;
}

@Component
export default class ListeTransfertSqlComponent extends VueBase {
    public listeElementsEnAttente: EntiteAttenteTransfertViewModel[] = [];
    public listeElementsEnAttenteFiltered: EntiteAttenteTransfertViewModel[] = [];
    public filtreRecherche = "";
    public currentOrderColumn = "EtatTransfert";
    public orderingDesc = true;
    public dataReady = false;
    public nbElementsSelectionnes = 0;

    /**
     * Cette fonction se lance à l'affichage de la page
     */
    public activated(): void {
        this.fetchData();
    }

    /**
     * Cette fonction se lance à la fermeture de la page
     */
    public deactivated(): void {
        this.listeElementsEnAttente = [];
        this.listeElementsEnAttenteFiltered = [];
        this.filtreRecherche = "";
        this.orderingDesc = true;
        this.currentOrderColumn = "EtatTransfert";
        this.dataReady = false;
    }

    public transmettreListeElements(): void {
        if (this.nbElementsSelectionnes > 0) {
            const elementsSelectionnes = this.listeElementsEnAttenteFiltered.filter(e => e.isSelected);

            const modalAlerte: ModalAlerteOptions = new ModalAlerteOptions(
                {
                    message: "Cette action va envoyer vos éléments aux équipes en charge de la gestion des fichiers SQL. Souhaitez-vous continuer ?",
                    callBackYes: () => {
                        this.dataReady = false;
                        ServicesFactoryInstance.EntiteEnAttenteService.transmettreListeEntites(elementsSelectionnes, () => {
                            NotificationServiceInstance.SendSuccess("Les éléments ont bien été envoyés");
                            this.fetchData();
                        }, () => {
                            NotificationServiceInstance.SendFailed("Une erreur est survenue lors de l'envoi des éléments");
                            this.fetchData();
                        });
                    },
                    callBackNo: () => {},
                    canClose: true,
                    showDialog: true,
                    title: "Confirmation"
                });
            EventBus.$emit(EventConstants.MODAL_ALERT, modalAlerte);


        } else {
            NotificationServiceInstance.SendInformation("Aucun élément n'a été sélectionné");
        }
    }

    /**
     * Trie par colonne ascendante ou descendante
     * @param columnName
     */
    public orderBy(columnName: string): void {
        if (this.currentOrderColumn == columnName) {
            this.orderingDesc = !this.orderingDesc;
        } else {
            this.orderingDesc = true;
        }
        this.currentOrderColumn = columnName;
        this.doOrder();
    }

    /**
     * Permet de trier la liste selon une colonne et de façon ascendante ou descendante
     */
    public doOrder(): void {
        if (this.listeElementsEnAttenteFiltered != undefined) {
            const orderingDesc = this.orderingDesc;
            const columnName = this.currentOrderColumn;

            if (columnName === "EtatTransfert") {
                this.doOrderByEtat();
            } else {
                this.listeElementsEnAttenteFiltered = this.listeElementsEnAttenteFiltered.sort(function (a, b) {
                    const valueA = a[columnName];
                    const valueB = b[columnName];


                    // Order des strings
                    if (valueA < valueB) {
                        return orderingDesc ? -1 : 1;
                    }
                    if (valueA > valueB) {
                        return orderingDesc ? 1 : -1;
                    }

                    return 0;
                });
            }
        }
    }

    /**
     * Permet de chercher des éléments par libelle ou par code
     * @returns
     */
    public doFilterRecherche(): void {
        if (this.filtreRecherche == undefined || this.filtreRecherche == "") {
            this.listeElementsEnAttenteFiltered = this.listeElementsEnAttente;

            return;
        } else {
            this.listeElementsEnAttenteFiltered = this.listeElementsEnAttente.filter(element =>
            (element.Libelle != undefined && (element.Libelle.toUpperCase().indexOf(this.filtreRecherche.toUpperCase()) >= 0) ||
                (element.Code != undefined && element.Code.toString().toUpperCase().indexOf(this.filtreRecherche.toUpperCase()) >= 0)));
        }

        this.doOrder();
    }

    /**
     * Compte le nombre d'éléments sélectionnés
     * @param element
     */
    public estSelectionneChanged(element: EntiteAttenteTransfertViewModel): void {
        if (element.isSelected) {
            this.nbElementsSelectionnes++;
        } else {
            this.nbElementsSelectionnes--;
        }
    }

    /**
     * Affiche ou pas la flèche montrant par quelle colonne la liste est triée
     * @param columnName
     * @param desc
     * @returns
     */
    public showOrderArrow(columnName: string, desc: boolean): string {
        if (columnName == this.currentOrderColumn && this.orderingDesc == desc) {
            return "active";
        }

        return "";
    }

    /**
     * Concatène un message avec la date de l'événement
     * @param message
     * @param dateEvenement
     * @returns
     */
    public getTitle(message: string, dateEvenement: Date): string {
        message += moment(dateEvenement).format("DD/MM/YYYY");
        return message;
    }

    /**
     * Récupère les informations nécessaires à l'affichage de la page
     */
    private fetchData(): void {
        ServicesFactoryInstance.EntiteEnAttenteService.getListeTransfertSql(data => {
            this.nbElementsSelectionnes = 0;
            this.filtreRecherche = "";
            this.listeElementsEnAttente = this.mapDossierToViewModel(data);
            this.listeElementsEnAttenteFiltered = this.listeElementsEnAttente;
            this.doOrder();

            this.dataReady = true;
        }, () => {
            NotificationServiceInstance.SendFailed("Une erreur est survenue lors de la récupération de la liste d'attente de transferts SQL");
            this.dataReady = true;
        });
    }

    /**
     * Tri via la colonne état
     */
    private doOrderByEtat(): void {
        this.listeElementsEnAttenteFiltered.sort((a, b) => {
            // Trier d'abord par état (En attente > Envoyé > Traité)
            if (a.EtatTransfert !== b.EtatTransfert) {
                return this.orderingDesc ? a.EtatTransfert - b.EtatTransfert : b.EtatTransfert - a.EtatTransfert;
            }

            // Si les deux éléments ont le même état, on trie par ordre chronologique
            const dateA = this.getDateForSorting(a);
            const dateB = this.getDateForSorting(b);

            if (a.EtatTransfert === EtatTransfertEnum.EnAttente) {
                // Pour les lignes en attente, on fait un tri "chronologique" grâce aux Id
                return this.orderingDesc ? b.Id - a.Id : a.Id - b.Id;
            } else if (dateA && dateB) {
                return this.orderingDesc ? dateB.getTime() - dateA.getTime() : dateA.getTime() - dateB.getTime();
            }

            return 0;
        });
    }

    /**
     * Génère une date pour le tri par la colonne état
     * @param element
     * @returns
     */
    private getDateForSorting(element: any): Date | null {
        if (element.EtatTransfert === EtatTransfertEnum.Envoye && element.DateEnvoi) {
            return new Date(element.DateEnvoi);
        }
        if (element.EtatTransfert === EtatTransfertEnum.Traite && element.DateTraitement) {
            return new Date(element.DateTraitement);
        }
        return null;
    }

    /**
     * Ajoute la propriété isSelected à tous les éléments de la liste
     * @param elements
     * @returns
     */
    private mapDossierToViewModel(elements: EntiteAttenteTransfertDto[]): EntiteAttenteTransfertViewModel[] {
        return elements.map((elt: EntiteAttenteTransfertDto) => ({
            ...elt,
            isSelected: false
        }));
    }

    public isDisabled(element: EntiteAttenteTransfertViewModel): boolean {
        return element.EtatTransfert !== EtatTransfertEnum.EnAttente;
    }

    public setTypeElement(element: EntiteAttenteTransfertViewModel): string {
        let typeElement = "";

        switch (element.NatureTransfert) {
            case NatureTransfertEnum.Rubrique:
                switch (element.CodeNature) {
                    case "P": {
                        typeElement = "Rubrique générale";
                        break;
                    }
                    case "S": {
                        typeElement = "Rubrique qualification";
                        break;
                    }
                    case "A": {
                        typeElement = "Rubrique bulletin";
                        break;
                    }
                    default:
                        break;
                }
                break;
            case NatureTransfertEnum.Tableau:
                typeElement = "Tableau";
                break;
            case NatureTransfertEnum.Scenario:
                typeElement = "Scénario";
                break;
            case NatureTransfertEnum.Libelle:
                typeElement = "Libellé";
                break;
            default:
                break;
        }

        return typeElement;
    }

    public removeElementTransfert(elementTransfertSql: EntiteAttenteTransfertViewModel): void {
        const modalAlerte: ModalAlerteOptions = new ModalAlerteOptions(
            {
                message: "Souhaitez vous réellement retirer cet élément de la liste ?",
                callBackYes: () => {
                    this.dataReady = false;
                    ServicesFactoryInstance.EntiteEnAttenteService.deleteElementListeTransfertSql(elementTransfertSql.Id, () => {
                        NotificationServiceInstance.SendSuccess(`L'élément '${elementTransfertSql.Libelle}' a été supprimer de la liste des transfert`);
                        this.fetchData();
                    }, () => {
                        NotificationServiceInstance.SendFailed("Une erreur est survenue lors de la récupération de la liste d'attente de transferts SQL");
                    });
                },
                callBackNo: () => { },
                canClose: true,
                showDialog: true,
                title: "Confirmation"
            });
        EventBus.$emit(EventConstants.MODAL_ALERT, modalAlerte);
    }
}



// WEBPACK FOOTER //
// ./src/components/listeTransfertSql/listeTransfertSql.ts